import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SnackbarService } from '@core/services/snackbar.service';
import { CustomSnackbarType } from '@shared/component/custom-snackbar/custom-snackbar.model';
import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Component({
	selector: 'sf-verify-email',
	templateUrl: './verify-email.component.html',
	styleUrls: ['./verify-email.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyEmailComponent {
	@Input() usedEmail: string;

	constructor(
		private authService: AuthService,
		private snackbarService: SnackbarService
	) {}

	public onResendEmail(): void {
		this.authService
			.resendConfirmationEmail(this.usedEmail)
			.pipe(
				catchError((error) => {
					if (error.status === 429) {
						this.snackbarService.openSnackbar({
							message: 'sf.module.auth.common.too_many_attempts',
							type: CustomSnackbarType.Error,
						});
					}
					return EMPTY;
				}),
				tap(() =>
					this.snackbarService.openSnackbar({
						message: 'sf.module.auth.common.email_sent',
						type: CustomSnackbarType.Success,
					})
				)
			)
			.subscribe();
	}
}
